import axios from 'axios'
import { attachAuthenticatedAxios } from '../modules/auth/core/authTokenService'
import { decryptResponse } from './decrypt'
import { API_BASE_URL } from '../../config/apiConfig'

const API_URL = API_BASE_URL

export const axiosClient = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

axiosClient.interceptors.response.use(async (res) => {
  if (res.data) {
    res.data = await decryptResponse(res.data)
  }
  return res
})

export const axiosClientAuth = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

attachAuthenticatedAxios(axiosClientAuth)
